import * as React from 'react';
import * as styles from './styles.css';
import cn from 'classnames';

import { ETrend } from '../../types/share';

export interface ITrendProps {
  trend: ETrend;
}

export function Trend({ trend }: ITrendProps) {
  if (trend === ETrend.NoChange) {
    return null;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={cn(trend === ETrend.Increase && styles['increase'])}
    >
      <path
        fill={'#737A8E'}
        fillRule="evenodd"
        d="M5 7V1h6v6h3.069a.8.8 0 01.565 1.366l-5.927 5.927a1 1 0 01-1.414 0L1.366 8.366A.8.8 0 011.93 7H5z"
        clipRule="evenodd"
      />
    </svg>
  );
}
